import { deserialize } from 'libs/cerialize';

export class TagModel {
    @deserialize
    Id: number;

    @deserialize
    Name: string;
}